export default "__VITE_ASSET__D5qUKUq2__"